import { prepareFormDataId } from '@/utils/form/prepareFormDataId'
import { prepareFormDataIdArray } from '@/utils/form/prepareFormDataIdArray'

function prepareProjectFormData (data) {
  const keyList = [
    'building',
    'object',
    'pto_responsible',
    'i_d',
    'customer',
    'general_contractor',
    'status',
    'sub_contractor',
    'treaty',
    'ppr_developer'
  ]

  const prepareFormData = prepareFormDataId(data, keyList)

  const keyListForIdArray = ['co_executors']

  return prepareFormDataIdArray(prepareFormData, keyListForIdArray)
}

function prepareProjectChangeFormData (data) {
  const keyListForId = [
    'file_type',
    'status'
  ]

  const prepareFormData = prepareFormDataId(data, keyListForId)

  const keyListForIdArray = ['jobs']

  return prepareFormDataIdArray(prepareFormData, keyListForIdArray)
}

function prepareProjectDocumentFormData (data) {
  const keyList = [
    'file_type',
    'status'
  ]

  return prepareFormDataId(data, keyList)
}

function prepareProjectStatementFormData (data) {
  const keyList = [
    'type'
  ]

  const prepareFormData = prepareFormDataId(data, keyList)

  const keyListForIdArray = ['jobs']

  return prepareFormDataIdArray(prepareFormData, keyListForIdArray)
}

function prepareProjectHandbookFormData (data) {
  const keyList = [
    'production_type',
    'building'
  ]

  return prepareFormDataId(data, keyList)
}

export {
  prepareProjectFormData,
  prepareProjectChangeFormData,
  prepareProjectDocumentFormData,
  prepareProjectStatementFormData,
  prepareProjectHandbookFormData
}
